"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerWrapper = exports.ScrollableDots = exports.ScrollWrapper = exports.ScrollSection = exports.ScrollContent = exports.ScrollBackground = exports.Li = exports.Dots = exports.DotWrapper = exports.Btn = exports.ArrowWrapper = exports.Arrow = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _white = _interopRequireDefault(require("../tokens/color/white"));
var _black = _interopRequireDefault(require("../tokens/color/black"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getPVArrowPosition = function getPVArrowPosition(props) {
  return props.isLeft ? "-4rem" : "-3rem";
};
var getArrowPosition = function getArrowPosition(props) {
  return props["default"] ? "-1.7rem" : props.isPhotoViewer ? getPVArrowPosition(props) : "3rem";
};
var getArrowVisibility = function getArrowVisibility(props) {
  return props["default"] || props.isPhotoViewer || props.forceArrowVisible ? "visible" : "hidden";
};
var getArrowOpacity = function getArrowOpacity(props) {
  return props["default"] || props.isPhotoViewer ? 1 : 0.6;
};
var getTop = function getTop(props) {
  return props.arrowFromTop || "auto";
};
var getLeftArrowWrapper = function getLeftArrowWrapper(props) {
  return props.isLeft ? getArrowPosition(props) : "unset";
};
var getRightArrowWrapper = function getRightArrowWrapper(props) {
  return props.isLeft ? "unset" : getArrowPosition(props);
};
var getMobileTop = function getMobileTop(props) {
  return props.mobileArrowFromTop || props.arrowFromTop || "auto";
};
var getLeftArrowWrapperForMobile = function getLeftArrowWrapperForMobile(props) {
  return props.isLeft ? props.isPhotoViewer ? "2rem" : "3rem" : "unset";
};
var getRightArrowWrapperForMobile = function getRightArrowWrapperForMobile(props) {
  return props.isLeft ? "unset" : props.isPhotoViewer ? "2rem" : "3rem";
};
var getOpacity = function getOpacity(props) {
  return props.active ? 0.75 : 0.25;
};
var getScrollSectionSize = function getScrollSectionSize(_ref) {
  var isSmallDot = _ref.isSmallDot;
  return "".concat(isSmallDot ? 0.75 : 1, "rem");
};
var ArrowWrapper = exports.ArrowWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1krzjx0-0"
})(["position:absolute;height:100%;width:", ";display:flex;align-items:center;visibility:", ";opacity:", ";left:", ";right:", ";", " @media (max-width:480px){width:3.4rem;}"], function (props) {
  return props.arrowHidden ? "0" : "3.4rem";
}, getArrowVisibility, getArrowOpacity, getLeftArrowWrapper, getRightArrowWrapper, function (props) {
  return props.isPhotoViewer && (0, _styledComponents.css)(["top:0;@media screen and (max-width:768px){left:", ";right:", ";}"], getLeftArrowWrapperForMobile, getRightArrowWrapperForMobile);
});
var SpinnerWrapper = exports.SpinnerWrapper = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-1krzjx0-1"
})(["height:3.4rem;width:3.4rem;background:", ";box-shadow:0 3px 5px -1px rgba(0,0,0,0.2),0 6px 10px 0 rgba(0,0,0,0.14),0 1px 18px 0 rgba(0,0,0,0.12);border-radius:50%;position:absolute;z-index:2;top:", ";display:\"initial\";border:4px solid transparent;display:flex;align-items:center;justify-content:center;"], _white["default"], getTop);
var Arrow = exports.Arrow = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-1krzjx0-2"
})(["font-size:0;height:", ";width:", ";background:", ";box-shadow:", ";border-radius:50%;position:absolute;z-index:2;top:", ";left:", ";right:", ";display:", ";border:", ";&:hover{background:", ";}&:active{background:", ";}&:focus{border-color:", ";box-shadow:", ";outline:none;}align-self:center;cursor:pointer;&:before{left:", ";transform:", ";top:0.9rem;position:absolute;width:0.9rem;height:0.9rem;content:\"\";border-color:", ";border-style:solid;border-top:0;border-right-width:2px;border-bottom-width:2px;border-left:0;font-size:13.5px;color:#696969;font-weight:bold;", "}@media (max-width:480px){top:", ";display:", ";", "}@media (max-width:768px) and (min-width:481px){display:", ";", "}"], function (props) {
  return props.isPhotoViewer ? "5.4rem" : "3.4rem";
}, function (props) {
  return props.isPhotoViewer ? "5.4rem" : "3.4rem";
}, function (props) {
  return props.isPhotoViewer ? "transparent" : _white["default"];
}, function (props) {
  return props.isPhotoViewer ? "none" : "0 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);";
}, getTop, function (_ref2) {
  var arrowInsetPadding = _ref2.arrowInsetPadding,
    isLeft = _ref2.isLeft;
  return isLeft ? arrowInsetPadding : "unset";
}, function (_ref3) {
  var arrowInsetPadding = _ref3.arrowInsetPadding,
    isLeft = _ref3.isLeft;
  return isLeft ? "unset" : arrowInsetPadding;
}, function (props) {
  return props.arrowHidden ? "none" : "initial";
}, function (props) {
  return props.isPhotoViewer ? "none" : "4px solid transparent";
}, function (props) {
  return props.isPhotoViewer ? "transparent" : _grey["default"].z100;
}, function (props) {
  return props.isPhotoViewer ? "transparent" : _grey["default"].z200;
}, _red["default"].z200, function (props) {
  return props.isPhotoViewer ? "none" : "-4px 5px 12px rgba(60, 64, 69, 0.12)";
}, function (props) {
  return props.isLeft ? "1rem" : "0.8rem";
}, function (props) {
  return props.isLeft ? "rotate(135deg)" : "rotate(-45deg)";
}, function (props) {
  return props.isPhotoViewer ? _white["default"] : _black["default"];
}, function (props) {
  return props.isPhotoViewer && (0, _styledComponents.css)(["@media screen and (min-width:768px){top:2.9rem;width:2.9rem;height:2.9rem;border-right-width:6px;border-bottom-width:6px;border-radius:4px;}@media screen and (max-width:768px){top:1.9rem;width:1.9rem;height:1.9rem;border-right-width:4px;border-bottom-width:4px;border-radius:3px;}"]);
}, getMobileTop, function (props) {
  return props.mobileArrowHidden ? "none" : "initial";
}, function (props) {
  return props.isPhotoViewer && (0, _styledComponents.css)(["height:3.4rem;width:3.4rem;"]);
}, function (props) {
  return props.tabArrowHidden ? "none" : "initial";
}, function (props) {
  return props.isPhotoViewer && (0, _styledComponents.css)(["height:3.4rem;width:3.4rem;"]);
});
var Li = exports.Li = /*#__PURE__*/_styledComponents["default"].li.withConfig({
  componentId: "sc-1krzjx0-3"
})(["margin:0px;position:relative;display:inline-block;width:", ";height:20px;padding:0;cursor:pointer;"], function (props) {
  return props.activeRedDots ? "1rem" : "2rem";
});
var Btn = exports.Btn = /*#__PURE__*/_styledComponents["default"].button.withConfig({
  componentId: "sc-1krzjx0-4"
})(["font-size:0;line-height:0;display:block;width:20px;height:20px;padding:5px;cursor:pointer;color:transparent;border:0;outline:none;background:transparent;&:before{font-size:", ";line-height:2rem;position:absolute;top:", ";left:0;width:20px;height:20px;content:\"\u2022\";text-align:center;opacity:", ";color:", ";-webkit-font-smoothing:antialiased;}"], function (props) {
  return props.activeRedDots ? props.active ? "3rem" : "2rem" : "4rem";
}, function (props) {
  return props.activeRedDots && props.activeRedDotsAdjusted && props.active ? "-1px" : 0;
}, getOpacity, function (props) {
  return props.activeRedDots && props.active ? _red["default"].z500 : "black";
});
var Dots = exports.Dots = /*#__PURE__*/_styledComponents["default"].ul.withConfig({
  componentId: "sc-1krzjx0-5"
})(["justify-content:", ";font-size:2.2rem;display:flex !important;position:absolute;bottom:", "rem;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center;"], function (_ref4) {
  var newCarouselDots = _ref4.newCarouselDots;
  return newCarouselDots ? "flex-start" : "center";
}, function (_ref5) {
  var isInside = _ref5.isInside;
  return isInside ? 1.5 : -2.5;
});
var ScrollContent = exports.ScrollContent = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-1krzjx0-6"
})(["&:before{display:", ";font-size:", ";line-height:1rem;position:absolute;left:0;content:\"\u2022\";text-align:center;color:", ";opacity:", ";width:1rem;}"], function (props) {
  return props.isVisible ? "block" : "none";
}, function (props) {
  return props.isSmallDot ? "2rem" : "3rem";
}, _white["default"], function (props) {
  return props.active ? 1 : 0.5;
});
var ScrollSection = exports.ScrollSection = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-1krzjx0-7"
})(["margin:0;margin-left:0.1rem;margin-right:0.1rem;position:relative;width:", ";height:", ";padding:0;", " ", ""], getScrollSectionSize, getScrollSectionSize, function (props) {
  return props.isFirstDot && (0, _styledComponents.css)(["margin-left:0.5rem;"]);
}, function (props) {
  return props.isLastDot && (0, _styledComponents.css)(["margin-right:0.5rem;"]);
});
var ScrollBackground = exports.ScrollBackground = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1krzjx0-8"
})(["position:absolute;background-color:", ";opacity:0.24;width:8.2rem;height:2rem;border-radius:1.2rem;"], _black["default"]);
var ScrollWrapper = exports.ScrollWrapper = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-1krzjx0-9"
})(["position:relative;width:8.2rem;overflow:hidden;touch-action:manipulation;margin:0;max-width:8.2rem;height:2rem;display:flex;align-items:center;"]);
var ScrollableDots = exports.ScrollableDots = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-1krzjx0-10"
})(["display:flex;align-items:center;margin:0;margin-bottom:0.4rem;transform:", ";transition:transform 0.45s ease-in-out 0s;"], function (props) {
  return "translateX(".concat(props.transitionWidth, "px)");
});
var DotWrapper = exports.DotWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1krzjx0-11"
})(["justify-content:center;font-size:2.2rem;display:flex !important;position:absolute;bottom:", "rem;display:block;padding:0;margin:0;width:100%;text-align:center;"], function (_ref6) {
  var isInside = _ref6.isInside;
  return isInside ? 1.5 : -3.5;
});